import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import MultiLineChartCard from 'components/DetailWidgets/MultiLineChartCard'
import ConversionFunnel from 'components/DetailWidgets/ConversionFunnel'
import RankedDonutCard from 'components/DetailWidgets/RankedDonutCard'

function ListCard({ title, action, children }) {
  return (
    <div className="w-full h-full rounded-2xl border border-border-lines p-4">
      <div className="flex items-center justify-between mb-3">
        <p className="text-base font-semibold text-dark-blue">{title}</p>
        {action}
      </div>
      <div className="flex flex-col gap-3">{children}</div>
    </div>
  )
}

function ViewAllLink({ children }) {
  return <button type="button" className="text-sm font-medium text-primary flex items-center gap-1 whitespace-nowrap">{children} <UIcons.UilArrowRight size={14} /></button>
}

export default function AnalyticsTab({ campaign }) {
  const { analytics } = campaign
  const [trendTab, setTrendTab] = useState(analytics.performanceTrends.tabs[0].key)

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {
          analytics.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilChartLine} label={stat.label} value={stat.value} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <MultiLineChartCard
        title="Performance Trends"
        series={analytics.performanceTrends.seriesByTab[trendTab]}
        tabs={analytics.performanceTrends.tabs}
        activeTab={trendTab}
        onTabChange={setTrendTab}
      />

      <div className="grid md:grid-cols-2 gap-4">
        <ConversionFunnel title="Campaign Participation Funnel" steps={analytics.funnel} />
        <RankedDonutCard
          title="Branch Performance"
          action={<ViewAllLink>View all Branches</ViewAllLink>}
          data={analytics.branchPerformance.data}
        />
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <ListCard title="Analytics Snapshot">
          {
            analytics.snapshot.map((item) => (
              <div key={item.key} className="flex items-center justify-between gap-3 text-sm">
                <p className="text-secondary">{item.label}</p>
                <p className={`font-medium ${item.tone === 'success' ? 'text-success' : 'text-dark-blue'}`}>{item.value}</p>
              </div>
            ))
          }
        </ListCard>

        <ListCard title="Prizes" action={<ViewAllLink>View all prizes</ViewAllLink>}>
          {
            analytics.prizes.map((prize) => (
              <p key={prize.key} className="text-sm text-dark-blue">{prize.name}</p>
            ))
          }
        </ListCard>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {
          analytics.participantQuality.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilUsersAlt} label={stat.label} value={stat.value} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <div className="w-full rounded-2xl border border-border-lines p-4">
        <p className="text-base font-semibold text-dark-blue mb-4">Levels &amp; Streaks Insights</p>

        <div className="grid grid-cols-2 gap-4 mb-4">
          {
            analytics.streakInsights.stats.map((stat) => (
              <StatCard key={stat.key} icon={UIcons.UilSync} label={stat.label} value={stat.value} tone={stat.tone} />
            ))
          }
        </div>

        <div className="w-full overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background">
                <th className="text-left font-semibold text-dark-blue px-3 py-2.5">Level</th>
                <th className="text-left font-semibold text-dark-blue px-3 py-2.5">Active Users</th>
                <th className="text-left font-semibold text-dark-blue px-3 py-2.5">Coin Bonus</th>
                <th className="text-left font-semibold text-dark-blue px-3 py-2.5">Points Bonus</th>
              </tr>
            </thead>
            <tbody>
              {
                analytics.streakInsights.table.map((row) => (
                  <tr key={row.level} className="border-b border-border-lines last:border-0">
                    <td className="px-3 py-2.5 text-dark-blue">{row.level}</td>
                    <td className="px-3 py-2.5 text-dark-blue">{row.activeUsers}</td>
                    <td className="px-3 py-2.5 text-dark-blue">{row.coinBonus}</td>
                    <td className="px-3 py-2.5 text-dark-blue">{row.pointsBonus}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
